module.exports = __webpack_public_path__ + "static/media/armine.e732262b.jpg";